import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query';

const { app } = PULSE;

export const accountHeaderBaseQuery = fetchBaseQuery({
    baseUrl: app.environment.api,
    prepareHeaders: (headers) => {
        headers.set(app.accountHeader.label, app.accountHeader.value);
        return headers;
    }
});
